import { render, staticRenderFns } from "./PropertyTable.vue?vue&type=template&id=6f01eab6&"
import script from "./PropertyTable.vue?vue&type=script&lang=js&"
export * from "./PropertyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports